import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/index';
import { Form, Input, Button, Spin, Card, Row, Col, Modal, Select, Popconfirm, Tabs, Icon, Table, Alert } from 'antd';
import './layout.css';
import LayoutHeader from '../Inc/Header';
import AdminNavigation from './AdminNavigation';
import CustomPopupModal from './customPopupModal';
import moment from 'moment';
import warningAlert from "../Membership/warning-alert.png"
import { LoadingOutlined } from '@ant-design/icons';
import { get, map } from 'lodash';
const TabPane = Tabs.TabPane;
const { Option } = Select;

const currentDate = new Date();

const NewRoles = ({ actions, searching, searchedGlobal, loading, positionList, assignRoleLoading, userInfoLoading, userInfo, getAllCouncils, councilsLoading, orgInfoLoading, orgInfo, superAdminInfo, personPositionList, activeRegistrationsLoading, activeRegistrations }) => {
    const [formValues, setFormValues] = useState({
        firstName: '',
        lastName: '',
        memberId: '',
    });
    const [formErrors, setFormErrors] = useState({});
    const [searchResults, setSearchResults] = useState([]);
    const [duplicateModalVisible, setDuplicateModalVisible] = useState(false);
    const [duplicateUsers, setDuplicateUsers] = useState([]);
    const [noRecordsModalVisible, setNoRecordsModalVisible] = useState(false);
    const [selectedRole, setSelectedRole] = useState('');
    const [extendRoleRecord, setExtendRoleRecord] = useState();
    const [roleSuccessModalVisible, setRoleSuccessModalVisible] = useState(false);
    const [activeTabKey, setActiveTabKey] = useState('1');
    const [roleActiveTabKey, roleSetActiveTabKey] = useState('1');
    const [loadingState, setLoadingState] = useState({});
    const [hasSearched, setHasSearched] = useState(false);
    const [selectedCouncils, setSelectedCouncils] = useState([]);
    const [selectedTerritory, setSelectedTerritory] = useState([]);
    const [validPositions, setValidPositions] = useState([]);
    // const [territoryLevelPositions, setTerritoryLevelPositions] = useState(null);
    // const [nationalLevelPositions, setNationalLevelPositions] = useState(null);
    // const [councilLevelPositions, setCouncilLevelPositions] = useState(null);
    const [rolesAboutToExpire, setRolesAboutToExpire] = useState([]);
    const [showCustomErrorPopup, setShowCustomErrorPopup] = useState({
        isShow: false,
        disabledRoleSelection: false,
        content: null
    });
    
    const [councilCommitteeUser, setCouncilCommitteeUser] = useState([]);

    console.log("superAdminInfo:", superAdminInfo);
    console.log("positionList:", positionList);
    console.log("personPositionList:", personPositionList)

    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        setFormValues({ ...formValues, [name]: typeof value == "string" ?  value.trim() : value });
    
        setFormErrors((prevErrors) => ({
            ...prevErrors,
            [name]: value.trim() === '' ? `Enter your ${formatLabel(name)}` : '',
        }));
    };
    
    const formatLabel = (name) => {
        switch (name) {
            case 'firstName': return 'First Name';
            case 'lastName': return 'Last Name';
            case 'memberId': return 'Member ID';
            default: return name;
        }
    };    

    const handleSubmit = (e) => {
        e.preventDefault();
        const { firstName, lastName, memberId } = formValues;
        let errors = {};

        if (!firstName) errors.firstName = 'Enter your First Name';
        if (!lastName) errors.lastName = 'Enter your Last Name';
        if (!memberId) errors.memberId = 'Enter your Member ID';

        setFormErrors(errors);

        if (Object.keys(errors).length === 0) {

            setSelectedRole(null);
            setSelectedCouncils([]);
            setSelectedTerritory(null);
            setSearchResults([]);
            setHasSearched(true);

            setShowCustomErrorPopup({
                isShow: false,
                disabledRoleSelection: false,
                content: null
            })

            actions.globalSearch({
                scout_first_name: firstName,
                scout_last_name: lastName,
                scout_member_id: memberId,
            });
            // actions.getAssignRolesPersonGuid();
        };
    }
    console.log("getAllCouncils:", getAllCouncils);

    useEffect(() => {
        if (hasSearched && Array.isArray(searchedGlobal)) {
            if (searchedGlobal.length > 0) {
                const { firstName, lastName, memberId } = formValues;

                const matchedPerson = searchedGlobal.find(person =>
                    person.firstName &&
                    person.lastName &&
                    firstName &&
                    lastName &&
                    person.firstName.toLowerCase() === firstName.toLowerCase() &&
                    person.lastName.toLowerCase() === lastName.toLowerCase() &&
                    person.memberId === memberId
                );

                if (matchedPerson) {
                    setSearchResults([matchedPerson]);
                    if (matchedPerson.personGuid) {
                        actions.getAssignRolesPersonGuid(matchedPerson.personGuid);
                    }
                } else {
                    setNoRecordsModalVisible(true);
                }
            } else {
                setNoRecordsModalVisible(true);
            }
        }
    }, [searchedGlobal, hasSearched]);

    useEffect(() => {
        if (!activeRegistrationsLoading && Array.isArray(activeRegistrations) && activeRegistrations.length) {
            const lastExpiringRegistration =  getValidPositions(true);
            if(lastExpiringRegistration) confirmRoleAssignment(lastExpiringRegistration);
        }
        else if(!activeRegistrationsLoading && Array.isArray(activeRegistrations) && activeRegistrations.length == 0){
            setLoadingState(prev => ({ ...prev, [`${extendRoleRecord.personGuid}-${extendRoleRecord.organizationGuid}-${extendRoleRecord.personContext}`]: false }));
            setExtendRoleRecord({});

            Modal.error({
                title: "Failed",
                content: "There is no paid position for this alumni",
                centered: true,
                // onOk() {
                    // window.location.reload();
                // }
            });
        }
    }, [activeRegistrationsLoading, activeRegistrations]);

    // useEffect(() => {
    //     if (
    //         Array.isArray(personPositionList) &&
    //         personPositionList.length &&
    //         Array.isArray(positionList) &&
    //         positionList.length
    //       ) {
    //         const councilCommitteeUser = personPositionList.reduce((acc, role) => {
    //           const orgCouncilsList = positionList
    //             .filter(
    //               pos =>
    //                 pos.memberId === role.memberId &&
    //                 pos.personGuid === role.personGuid 
    //                 // && moment(pos.effectiveDate).isSame(role.effectiveDt, 'day') &&
    //                 // moment(pos.expireDate || null).isSame(role.expiryDt || null, 'day')
    //             )
    //             .map(pos => pos.orgDisplayName);
          
    //           acc.push({
    //             ...role,
    //             ...(orgCouncilsList.length > 0 && {
    //               name: orgCouncilsList.join(', ')
    //             })
    //           });
          
    //           return acc;
    //         }, []);
          
    //          setCouncilCommitteeUser(councilCommitteeUser);
    //       }          
    // },[personPositionList, positionList]);

    const handleCouncilSelect = (value) => {
        setSelectedCouncils(value);
    };
    
    const closeCustomErrorPopup = () => {
        return setShowCustomErrorPopup({
            ...showCustomErrorPopup,
            isShow: false,
            content: null
        })
    }

    const showCustomPopupModal = () => {
        if (showCustomErrorPopup.content == 'effectiveDatePopup') {
            return <CustomPopupModal 
            doesShowPopup={showCustomErrorPopup.isShow} 
            closePopup={closeCustomErrorPopup} 
            popupTitle={"Role Assignment Not Yet Available"} 
            popupPrimaryContent={<div className='margin-bottom-20'>This alum’s registration becomes active mid-month. Due to system rules, roles can only be assigned starting next month.</div>}
            popupSecondaryContent={<div>Please assign the role after the 1st of next month, when the registration aligns with role assignment requirements.</div>}
            />
        } else if(showCustomErrorPopup.content == 'expirationDatePopup') {
            return <CustomPopupModal 
            doesShowPopup={showCustomErrorPopup.isShow} 
            closePopup={closeCustomErrorPopup} 
            popupTitle={"Cannot Assign/Extend Role – Registration Expiring Soon"} 
            popupPrimaryContent={<div className='margin-bottom-20'>This alum’s registration is set to expire within the current month. Roles cannot be assigned/renewed to registrations that are about to expire.</div>}
            popupSecondaryContent={<div>Please plan to renew/reactivate this alum's role assignment after the first of next month in accordance with system rules.</div>} 
            />
        }
        else return;
       
    }

    useEffect(() => {
        (actions.getSuperAdmin());
    }, []);

    const checkPositionsLevels = (postion, level) => {
        if(level == 'nationalLevel' && postion.OrgType.toLowerCase().includes('national')) return true;
        if(level == 'councilLevel' && postion.OrgType.toLowerCase().includes('council')) return true;
        if(level == 'territoryLevel' && (postion.OrgType.toLowerCase().includes('territory') || postion.OrgType.toLowerCase().includes('territories'))) return true;
        return false; //if both contitions are not true;
    };

    useEffect(() => {
        if (!userInfoLoading && Array.isArray(userInfo) && userInfo.length === 0) {
            Modal.error({
                title: "Failed",
                content: "There is no paid position for this alumni",
                centered: true,
                // onOk() {
                    // window.location.reload();
                // }
            });
            setLoadingState({});
            setShowCustomErrorPopup({
                isShow: false, // No need to display the custom popup for no valid position instead, we display the above popup
                disabledRoleSelection: true, //to disable the assign role's input
                content: null
            })
        } else if (!userInfoLoading && Array.isArray(userInfo) && userInfo.length > 0) {
            getValidPositions();

            // const filteredValidPositions = getValidPositions();
            // if (Array.isArray(filteredValidPositions) && filteredValidPositions.length > 0) {
        
            //     const today = moment();
            //     const thisMonth = today.month(); // 0-based
            //     const thisYear = today.year(); // 4-digit year
        
            //     //Filter out positions that become effective this month
            //     const positionsToConsider = filteredValidPositions.filter(pos => {
            //         // Ensure EffectiveDt exists and is a valid moment date
            //         const effectiveMoment = moment(pos.EffectiveDt);
            //         if (!effectiveMoment.isValid()) {
            //             return false; // Skip invalid or missing effective dates
            //         }
        
            //         // Return true if the position is NOT effective in the current month
            //         return !(effectiveMoment.year() === thisYear && effectiveMoment.month() === thisMonth);
            //     });
        
            //     //After filtered out the positions that become effective this month, if there are no postions then display the "effectiveDatePopup"
            //     if (positionsToConsider.length === 0) {
            //         return setShowCustomErrorPopup({
            //             isShow: true,
            //             disabledRoleSelection: true,
            //             content: 'effectiveDatePopup'
            //         });
            //     }
            //     let getTerritoryLevelPositions = null;
            //     let getNationalLevelPositions = null;

            //     const lastExpiringRegistration = positionsToConsider.reduce((latestPos, currentPos) => {
            //         const latestExpiry = latestPos.ExpiryDt ? moment(latestPos.ExpiryDt) : moment.max();
            //         const currentExpiry = currentPos.ExpiryDt ? moment(currentPos.ExpiryDt) : moment.max();

            //         // To get the National-level positions
            //         if (checkPositionsLevels(currentPos, 'nationalLevel')) {
            //             if (checkPositionsLevels(latestPos, 'nationalLevel')) {
            //                 getNationalLevelPositions = currentExpiry.isAfter(latestExpiry) ? currentPos : latestPos;
            //             } else {
            //                 getNationalLevelPositions = currentPos;
            //             }
            //         }
                    
            //         // To get the Territory-level positions
            //         if (checkPositionsLevels(currentPos, 'territoryLevel')) {
            //             if (checkPositionsLevels(latestPos, 'territoryLevel')) {
            //                 getTerritoryLevelPositions = currentExpiry.isAfter(latestExpiry) ? currentPos : latestPos;
            //             } else {
            //                 getTerritoryLevelPositions = currentPos;
            //             }
            //         }

            //         // Update the latest expiring position overall
            //         return currentExpiry.isAfter(latestExpiry) ? currentPos : latestPos;
            //     });
        
            //     const effectiveMoment = moment(lastExpiringRegistration.EffectiveDt);
            //     const expiryMoment = moment(lastExpiringRegistration.ExpiryDt);
                
            //     // if (effectiveMoment.isValid()) {
            //     //     const effDay = effectiveMoment.date();
            //     //     const effMonth = effectiveMoment.month();
            //     //     const effYear = effectiveMoment.year();
        
            //     //     if (effMonth === thisMonth && effYear === thisYear && effDay !== 1) {
            //     //         return setShowCustomErrorPopup({
            //     //             isShow: true,
            //     //             disabledRoleSelection: true,
            //     //             content: 'effectiveDatePopup'
            //     //         });
            //     //     }
            //     // }
                
            //     if (expiryMoment.isValid()) {
            //         const expDay = expiryMoment.date();
            //         const expMonth = expiryMoment.month();
            //         const expYear = expiryMoment.year();
            //         const lastDayOfCurrentMonth = today.clone().endOf('month').date();
                    
            //         if (expMonth === thisMonth && expYear === thisYear && expDay !== lastDayOfCurrentMonth) {
            //             return setShowCustomErrorPopup({
            //                 isShow: true,
            //                 disabledRoleSelection: true,
            //                 content: 'expirationDatePopup'
            //             });
            //         }
            //     }
            //     setValidPositions(lastExpiringRegistration) //We use this position's ORG-GUID for assigning the Alum's selected role because it's the last one to expire in their list of positions.
            //     setTerritoryLevelPositions(getTerritoryLevelPositions)
            //     setNationalLevelPositions(getNationalLevelPositions)
            // }
            // else setShowCustomErrorPopup({
            //     isShow: false, // No need to display the custom popup for no valid position instead, we display another popup
            //     disabledRoleSelection: true, //to disable the assign role's input
            //     content: null
            // })
        }
    }, [userInfoLoading, userInfo]);

    const filteredPositions = Array.isArray(userInfo)
        ? userInfo.filter((position) =>
            [781, 782, 783].includes(position.PKPositionId)
        )
        : [];

    const uniquePositions = filteredPositions.reduce((acc, current) => {
        if (!acc.some(item => item.PKPositionId === current.PKPositionId)) {
            acc.push(current);
        }
        return acc;
    }, []);

    const selectDuplicateUser = (user) => {
        setSearchResults([user]);
        setDuplicateModalVisible(false);
    };

    const noRecordscloseModal = () => {
        setNoRecordsModalVisible(false);
        setHasSearched(false);
    };

    const handleRoleSelect = (value, index) => {
        setSelectedRole(value);
        setSelectedCouncils([]);
    };

    const handleTerritorySelect = (value, index) => {
        setSelectedTerritory(value);
        if(selectedRole == 'AlumniCouncilCommittee' ) actions.getCouncilsByTerritory(value);
    };

    const getValidPositions = (ForExtendRole) => {
        let lastExpiringRegistration;
        const activeReg = ForExtendRole ? activeRegistrations : userInfo;
        let filteredValidPositions = Array.isArray(activeReg)
            ? activeReg.filter(p => p.OrganizationGuid && p.OrganizationGuid.trim() !== "" && (!p.IsFunctional)) // IsFunctional is should be false, as per Sangeeta's comment on AAG-1215, To assign a functional position in any organization, person should have a registered position
            : [];

        if (filteredValidPositions.length === 0) {
            setShowCustomErrorPopup({
                isShow: false, // No need to display the custom popup for no valid position instead, we display another popup
                disabledRoleSelection: true, //to disable the assign role's input
                content: null
            })
            Modal.error({
                title: 'No Valid Position Found',
                content: 'This member does not have any valid positions with an Organization GUID.',
                centered: true,
            });
            setLoadingState({});
            return;
        } else {
                const today = moment();
                const thisMonth = today.month(); // 0-based
                const thisYear = today.year(); // 4-digit year
        
                //Filter out positions that become effective this month
                const positionsToConsider = filteredValidPositions.filter(pos => {
                    // Ensure EffectiveDt exists and is a valid moment date
                    const effectiveMoment = moment(pos.EffectiveDt);
                    if (!effectiveMoment.isValid()) {
                        return false; // Skip invalid or missing effective dates
                    }
        
                    // Return true if the position is NOT effective in the current month
                    return !(effectiveMoment.year() === thisYear && effectiveMoment.month() === thisMonth);
                });
        
                //After filtered out the positions that become effective this month, if there are no postions then display the "effectiveDatePopup"
                if (positionsToConsider.length === 0) {
                    setLoadingState({});
                    return setShowCustomErrorPopup({
                        isShow: true,
                        disabledRoleSelection: true,
                        content: 'effectiveDatePopup'
                    });
                }
                // let getTerritoryLevelPositions = null; //EAGRE-8402
                // let getNationalLevelPositions = null;
                // let getCouncilLevelPositions = null;

                lastExpiringRegistration = positionsToConsider.reduce((latestPos, currentPos) => {
                    const latestExpiry = latestPos.ExpiryDt ? moment(latestPos.ExpiryDt) : moment.max();
                    const currentExpiry = currentPos.ExpiryDt ? moment(currentPos.ExpiryDt) : moment.max();

                    // To get the National-level positions //EAGRE-8402
                    // if (checkPositionsLevels(latestPos, 'nationalLevel')) {
                    //     if (checkPositionsLevels(currentPos, 'nationalLevel')) {
                    //         getNationalLevelPositions = currentExpiry.isAfter(latestExpiry) ? currentPos : currentPos;
                    //     } else {
                    //         getNationalLevelPositions = latestPos;
                    //     }
                    // }
                    // if (checkPositionsLevels(latestPos, 'councilLevel')) {
                    //     if (checkPositionsLevels(currentPos, 'councilLevel')) {
                    //         getCouncilLevelPositions = currentExpiry.isAfter(latestExpiry) ? currentPos : latestPos;
                    //     } else {
                    //         getCouncilLevelPositions = latestPos;
                    //     }
                    // }
                    
                    // // To get the Territory-level positions
                    // if (checkPositionsLevels(latestPos, 'territoryLevel')) {
                    //     if (checkPositionsLevels(currentPos, 'territoryLevel')) {
                    //         getTerritoryLevelPositions = currentExpiry.isAfter(latestExpiry) ? currentPos : latestPos;
                    //     } else {
                    //         getTerritoryLevelPositions = latestPos;
                    //     }
                    // }

                    // Update the latest expiring position overall
                    return currentExpiry.isAfter(latestExpiry) ? currentPos : latestPos;
                });
        
                const effectiveMoment = moment(lastExpiringRegistration.EffectiveDt);
                const expiryMoment = moment(lastExpiringRegistration.ExpiryDt);
                
                // if (effectiveMoment.isValid()) {
                //     const effDay = effectiveMoment.date();
                //     const effMonth = effectiveMoment.month();
                //     const effYear = effectiveMoment.year();
        
                //     if (effMonth === thisMonth && effYear === thisYear && effDay !== 1) {
                //         return setShowCustomErrorPopup({
                //             isShow: true,
                //             disabledRoleSelection: true,
                //             content: 'effectiveDatePopup'
                //         });
                //     }
                // }
                
                if (expiryMoment.isValid()) {
                    const expDay = expiryMoment.date();
                    const expMonth = expiryMoment.month();
                    const expYear = expiryMoment.year();
                    const lastDayOfCurrentMonth = today.clone().endOf('month').date();
                    const lastDayOfNextMonth = today.clone().add(1, 'month').endOf('month').format('YYYY-MM-DD');
                    
                    if (expMonth === thisMonth && expYear === thisYear && expDay !== lastDayOfCurrentMonth) {
                        setLoadingState({});
                        return setShowCustomErrorPopup({
                            isShow: true,
                            disabledRoleSelection: true,
                            content: 'expirationDatePopup'
                        });
                    }
                    if(ForExtendRole){
                        const lastExpirationDate = lastExpiringRegistration.ExpiryDt ? moment(lastExpiringRegistration.ExpiryDt).format('YYYY-MM-DD') : moment.max();
                        if(moment(lastDayOfNextMonth).isSameOrAfter(lastExpirationDate, 'day')){ //Checks the last active registration with an expiration date after the next month, since CORE only allows expiration dates that fall on the last day of a month.
                            setLoadingState(prev => ({ ...prev, [`${extendRoleRecord.personGuid}-${extendRoleRecord.organizationGuid}-${extendRoleRecord.personContext}`]: false }));
                            setExtendRoleRecord({})
                            return setShowCustomErrorPopup({
                                isShow: true,
                                disabledRoleSelection: true,
                                content: 'expirationDatePopup'
                            });
                        }
                    }
                }
                setValidPositions(lastExpiringRegistration) //We use this position's ORG-GUID for assigning the Alum's selected role because it's the last one to expire in their list of positions.
                // setTerritoryLevelPositions(getTerritoryLevelPositions) //EAGRE-8402
                // setNationalLevelPositions(getNationalLevelPositions)
                // setCouncilLevelPositions(getCouncilLevelPositions)
            }

            return lastExpiringRegistration;
    }

    const confirmRoleAssignment = (extendRole_ActiveRegistrations) => {
        const currentDate = new Date();
        const effectiveDate = extendRoleRecord && extendRoleRecord.expireDate ? moment(extendRoleRecord.expireDate).add(1, 'day').format('YYYY-MM-DD') : currentDate.toISOString().split('T')[0];

        const personGuid = extendRoleRecord ? extendRoleRecord.personGuid : searchedGlobal[0].personGuid;
        const assignedMember = extendRoleRecord ? extendRoleRecord.memberId : searchResults[0].memberId;
        let MID = assignedMember;
        let Role = '';
        let TerritoryID = '';
        let CouncilsID = [];

        if (extendRoleRecord && extendRoleRecord.personContext == 'AlumniCouncilCommittee'){
            CouncilsID = [extendRoleRecord.organizationGuid];
        }
        else if (selectedRole == "AlumniCouncilCommittee") {
            CouncilsID = [...selectedCouncils];
        }

        if (extendRoleRecord && extendRoleRecord.personContext == 'AlumniCSTSupport'){
            TerritoryID = extendRoleRecord.organizationGuid;
        }
        else if (selectedRole == "AlumniCSTSupport") {
            TerritoryID = '';
        }

        // AAG-1370: when adding a role (not extending), if the person already has this same role
        // (matched by PositionLong) in the getAssignRolesPersonGuid response, skip the
        // assignFunctional/getValidPositions flow and just (re)confirm the assignment directly.
        if (!extendRoleRecord) {
            const positionLongMap = {
                AlumniCouncilCommittee: "Alumni Council Committee",
                AlumniCSTSupport: "Alumni CST Support",
                AlumniAdmin: "Alumni Admin",
            };
            const targetPositionLong = positionLongMap[selectedRole];
            const matchingRoles = Array.isArray(userInfo)
                ? userInfo.filter(p => p.PositionLong === targetPositionLong)
                : [];

            // Among matches, the latest is either the one with no expiry (open-ended) or the
            // one with the furthest ExpiryDt.
            const latestMatch = matchingRoles.reduce((latest, current) => {
                if (!latest) return current;
                if (!latest.ExpiryDt) return latest;
                if (!current.ExpiryDt) return current;
                return moment(current.ExpiryDt).isAfter(moment(latest.ExpiryDt)) ? current : latest;
            }, null);

            if (latestMatch) {
                const today = moment();
                const expiryMoment = latestMatch.ExpiryDt ? moment(latestMatch.ExpiryDt) : null;

                // CORE only allows expiration dates on the last day of a month. If this match
                // ends this month but not on the month's last day, it's not a clean case to
                // extend directly -- skip this block and fall through to the existing flow.
                // const endedThisMonthNotLastDay = expiryMoment && expiryMoment.isValid() &&
                //     expiryMoment.month() === today.month() &&
                //     expiryMoment.year() === today.year() &&
                //     expiryMoment.date() !== today.clone().endOf('month').date();

                // if (!endedThisMonthNotLastDay) {
                    const directEffectiveDate = today.format('YYYY-MM-DD');
                    const directExpiryDate = (expiryMoment && expiryMoment.isAfter(today, 'day'))
                        ? expiryMoment.format('YYYY-MM-DD')
                        : moment().add(1, 'year').format('YYYY-MM-DD');

                    actions.assignPersonPositionDirectForRole(MID, selectedRole, selectedTerritory, CouncilsID, directEffectiveDate, directExpiryDate)
                        .then(async () => {
                            setFormValues({
                                firstName: '',
                                lastName: '',
                                memberId: '',
                            });
                            setSearchResults([]);
                            roleSetActiveTabKey("2");

                            await actions.getAssignRolesPositions();
                            await actions.getOrganizationPostion();

                            if (selectedRole === "AlumniCouncilCommittee") {
                                setActiveTabKey('1');
                            } else if (selectedRole === "AlumniCSTSupport") {
                                setActiveTabKey('2');
                            } else if (selectedRole === "AlumniAdmin") {
                                setActiveTabKey('3');
                            }
                        })
                        .catch((error) => {
                            console.error("Error during role assignment:", error);
                        });
                    return;
                // }
            }
        }

        // let paidOrgGuid = null

        // const paidPosition = Array.isArray(userInfo) 
        //     ? userInfo.find(position => position.IsPaidPosition === true) 
        //     : null;

        // if (paidPosition && paidPosition.OrganizationGuid) {
        //     paidOrgGuid = paidPosition.OrganizationGuid;
        // } else {
        //     Modal.error({
        //         title: 'No Paid Position Found',
        //         content: 'This member does not have a paid position. Cannot assign this role.',
        //         centered: true,
        //     });
        //     return;
        // }

        let selectedPosition =  extendRole_ActiveRegistrations || validPositions;
        let positionOrgGuid = selectedPosition.OrganizationGuid;

        //EAGRE-8402
        // if (selectedRole === "AlumniAdmin" && nationalLevelPositions) { //If the user selects the "AlumniAdmin" Role, we check to see if there are any national-level registrations. If so, we assign them to the national level for roleType validations.
        //     selectedPosition = nationalLevelPositions;
        //     positionOrgGuid = nationalLevelPositions.OrganizationGuid;
        // }
        // else if (selectedRole === "AlumniCSTSupport") { //If the user selects the "CST Support" Role, we check to see if there are any national-level or territory-level registrations. If so, we assign them to the national/territory level for roleType validations.
        //     const pos = nationalLevelPositions || territoryLevelPositions;
        //     if (pos) {
        //       selectedPosition = pos;
        //       positionOrgGuid = pos.OrganizationGuid;
        //     }
        // }
        // else if (selectedRole === "AlumniCouncilCommittee") {
        //     const pos = councilLevelPositions;
        //     if (pos) {
        //       selectedPosition = pos;
        //       positionOrgGuid = pos.OrganizationGuid;
        //     }
        // }
          
    
        const today = new Date();

        let finalExpiry 

        // const futureExpiries = validPositions
        //     .filter(p => p.ExpiryDt)
        //     .map(p => new Date(p.ExpiryDt))
        //     .filter(date => date > today);

        // if (futureExpiries.length > 0) {
        //     const furthest = new Date(Math.max.apply(null, futureExpiries));
        //     furthest.setDate(furthest.getDate() - 1);
        //     furthest.setMonth(furthest.getMonth() - 1);
        //     finalExpiry = furthest > oneYearLater ? furthest : oneYearLater;
        // }

        if (selectedPosition.ExpiryDt) {
            let positionsExpiryDate = moment(selectedPosition.ExpiryDt);
            const positionsExpiryDay = positionsExpiryDate.date();

            const lastDayOfPositionsExpiryMonth = positionsExpiryDate.clone().endOf('month').date();
            if ((positionsExpiryDate > today) && (positionsExpiryDay == lastDayOfPositionsExpiryMonth)) { //set positions Expiration date as registrations expiration date if it is the last day of month.
                finalExpiry = positionsExpiryDate;
            }
            else if (positionsExpiryDate > today && (positionsExpiryDay < lastDayOfPositionsExpiryMonth)) {
                positionsExpiryDate = new Date(positionsExpiryDate);
                positionsExpiryDate.setMonth(positionsExpiryDate.getMonth() - 1);
                positionsExpiryDate.setDate(positionsExpiryDate.getDate() - 1);
                finalExpiry = positionsExpiryDate;
            } else {
                const oneYearLater = new Date(today);
                oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
                finalExpiry = oneYearLater;
            }
        } else {
            const oneYearLater = new Date(today);
            oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
            finalExpiry = oneYearLater;
        }

        const finalExpiryDate = finalExpiry.toISOString().split('T')[0];

        actions.assignRolesFunctional(personGuid, MID, selectedRole, selectedTerritory, CouncilsID, effectiveDate, finalExpiryDate, positionOrgGuid)
            .then(async () => {
                setFormValues({
                    firstName: '',
                    lastName: '',
                    memberId: '',
                });

                setSearchResults([]);
                roleSetActiveTabKey("2")
                
                await actions.getAssignRolesPositions();
                await actions.getOrganizationPostion();

                if (selectedRole) {
                    if (selectedRole === "AlumniCouncilCommittee") {
                        setActiveTabKey('1');
                    } else if (selectedRole === "AlumniCSTSupport") {
                        setActiveTabKey('2');
                    } else if (selectedRole === "AlumniAdmin") {
                        setActiveTabKey('3');
                    }
                }
                if (extendRoleRecord) {
                    setLoadingState(prev => ({ ...prev, [`${extendRoleRecord.personGuid}-${extendRoleRecord.organizationGuid}-${extendRoleRecord.personContext}`]: false }));
                    setExtendRoleRecord({})
                }
            })
            .catch((error) => {
                if (extendRoleRecord) {
                    setLoadingState(prev => ({ ...prev, [`${extendRoleRecord.personGuid}-${extendRoleRecord.organizationGuid}-${extendRoleRecord.personContext}`]: false }));
                    setExtendRoleRecord({})
                }
                console.error("Error during role assignment:", error);
            });
    };

    const roleDisplayNameMap = {
        AlumniCouncilCommittee: "Alumni Council Committee",
        AlumniCSTSupport: "Alumni CST Support",
        AlumniAdmin: "Alumni Admin",
    };

    const handleConfirmRoleAssignment = () => {
        Modal.confirm({
            title: 'Confirm Role Assignment',
            content: (
                <p>
                    Do you want to assign this person to the <br /><span className='which-role'>{roleDisplayNameMap[selectedRole] || selectedRole }</span> role?
                </p>
            ),
            // content: `Are you sure you want to assign the role: ${roleDisplayNameMap[selectedRole] || selectedRole}?`,
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => confirmRoleAssignment(),
            onCancel: () => { }
        });
    };

    const handleCancel = (index) => {
        setSearchResults((prevResults) => prevResults.filter((_, i) => i !== index));
    };

    // const getColumns = (positionLong) => {
    //     const baseColumns = [
    //         {
    //             title: 'First Name',
    //             dataIndex: 'firstName',
    //             key: 'firstName',
    //             render: (text) => (text ? text : '–'),
    //         },
    //         {
    //             title: 'Last Name',
    //             dataIndex: 'lastName',
    //             key: 'lastName',
    //             render: (text) => (text ? text : '–'),
    //         },
    //         {
    //             title: 'Org Name',
    //             dataIndex: positionLong == "Super Alumni Administrator" ? 'name' : 'orgDisplayName',
    //             key: positionLong == "Super Alumni Administrator" ? 'name' : 'orgDisplayName',
    //             render: (text) => (text ? text : '–'),
    //         },
    //         {
    //             title: 'Effective Date',
    //             dataIndex: positionLong == "Super Alumni Administrator" ? 'effectiveDt' : 'effectiveDate',
    //             key: positionLong == "Super Alumni Administrator" ? 'effectiveDt' : 'effectiveDate',
    //             render: (text) => {
    //                 const date = new Date(text);
    //                 return !isNaN(date) ? date.toISOString().split('T')[0] : '–';
    //             },
    //         },
    //         {
    //             title: 'Expiry Date',
    //             dataIndex: 'expireDate',
    //             key: 'expireDate',
    //             render: (text, record) => {
    //                 const date = new Date(record.expireDate || record.expiryDt);
    //                 return !isNaN(date) ? date.toISOString().split('T')[0] : '–';
    //             },
    //         },
    //     ];

        // if (positionLong !== "Super Alumni Administrator") {
        //     baseColumns.push({
        //         title: 'Role Remove',
        //         key: 'action',
        //         render: (_, record) => (
        //             <Popconfirm
        //                 title="Are you sure you want to remove this role?"
        //                 onConfirm={() => handleDelete(record.memberId, record.organizationGuid, record.personContext, record.effectiveDate, record)}
        //                 okText="Yes"
        //                 cancelText="No"
        //             >
        //                 <Button
        //                     type="danger"
        //                     icon={<Icon type="delete" />}
        //                     className='role-remove-btn'
        //                     loading={loadingState[record.personGuid] || false}
        //                 >
        //                     Remove
        //                 </Button>
        //             </Popconfirm>
        //         ),
        //     });
        // }
    //     return baseColumns;
    // };

    const getColumns = (positionLong, tab) => {
        const baseColumns = [
            {
                title: 'First Name',
                dataIndex: 'firstName',
                key: 'firstName',
                render: (text) => (text ? text : '–'),
            },
            {
                title: 'Last Name',
                dataIndex: 'lastName',
                key: 'lastName',
                render: (text) => (text ? text : '–'),
            },
            {
                title: 'Member ID',
                dataIndex: 'memberId',
                key: 'memberId',
                render: (text) => (text ? text : '–'),
            },
            {
                title: 'Org Name',
                dataIndex: positionLong == "Super Alumni Administrator" ? 'name' : 'orgDisplayName',
                key: positionLong == "Super Alumni Administrator" ? 'name' : 'orgDisplayName',
                // dataIndex:  'orgDisplayName',
                // key:  'orgDisplayName',
                render: (text) => (text ? text : '–'),
            },
            {
                title: 'Effective Date',
                dataIndex: positionLong == "Super Alumni Administrator" ? 'effectiveDt' : 'effectiveDate',
                key: positionLong == "Super Alumni Administrator" ? 'effectiveDt' : 'effectiveDate',
                // dataIndex:  'effectiveDate',
                // key:  'effectiveDate',
                render: (text) => {
                    const date = new Date(text);
                    return !isNaN(date) ? date.toISOString().split('T')[0] : '–';
                },
            },
            {
                title: 'Expiry Date',
                dataIndex: positionLong == "Super Alumni Administrator" ? 'expiryDt' : 'expireDate',
                key: positionLong == "Super Alumni Administrator" ? 'expiryDt' : 'expireDate',
                // dataIndex: 'expireDate',
                // key: 'expireDate',
                render: (text) => {
                    if (!text) return '–';
                    const date = new Date(text);
                    return !isNaN(date) ? date.toISOString().split('T')[0] : '–';
                },
            },
        ];

        if (tab == 'rolesAboutToExpire') {
            baseColumns.push(
                {
                    title: 'Role',
                    dataIndex: 'personContext',
                    key: 'personContext',
                    render: (text) => (text ? text.replaceAll(' ', '') : '–'),
                },
                {
                title: 'Days Remains',
                key: 'daysRemains',
                render: (_, record) => {
                    const expDate = (record && record.expireDate) || (record && record.expiryDt);
                
                    if (!expDate) return 'N/A';
                
                    const currentDate = new Date();
                    const expirationDate = new Date(expDate);
                    const diffTime = expirationDate - currentDate;
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                
                    let color = 'inherit'; // default
                    if (diffDays < 0) {
                        color = 'gray'; // already expired
                    } else if (diffDays <= 10) {
                        color = 'red'; // urgent
                    } else if (diffDays <= 25) {
                        color = 'orange'; // warning
                    } else {
                        color = 'green'; // safe
                    }
                
                    return <span style={{ color }}>{`${diffDays} day(s)`}</span>;
                }
            },
            {
                title: 'Extend Role',
                key: 'ExtendRole',
                render: (_, record) => {
                  return (
                    <Popconfirm
                      title={
                        <p>
                          Do you want to extend this person's <br />
                          <span className="which-role">{record.personContext}</span> role?
                        </p>
                      }
                      onConfirm={() => {
                        const selectedRole = record.personContext;
                        setSelectedRole(selectedRole);
                        setExtendRoleRecord(record);
                        setLoadingState(prev => ({ ...prev, [`${record.personGuid}-${record.organizationGuid}-${record.personContext}`]: true }));

                        if (selectedRole === 'AlumniCouncilCommittee') {
                          setSelectedCouncils(record.organizationGuid);
                        } else if (selectedRole === 'AlumniCSTSupport' || selectedRole === 'AlumniAdmin') {
                          setSelectedTerritory(record.organizationGuid);
                        }
                        // AAG-1370 AAG-1370 extend role directly when person's position is still active

                          // When extending a role, check personPositionList (GET /organizations/v2/organizations/{positionId}) for the person's
                          // matching position. If its expiration date is in the future or null, call NESAPersonPosition/assign directly with the effective
                          // date set to the day after the current expiry and the expiration date
                          // from personPositionList (GET /organizations/v2/organizations/{positionId}), instead of going through the full
                          // /position -> getValidPositions -> assignRolesFunctional flow. (Falls back to the existing
                          // extend-role flow when the position has already expired.)

                        const positionLongMap = {
                          AlumniCouncilCommittee: "Alumni Council Committee",
                          AlumniCSTSupport: "Alumni CST Support",
                          AlumniAdmin: "Alumni Admin",
                        };
                        const targetPositionLong = positionLongMap[selectedRole];

                        // fetch it fresh here rather than trusting the prop.
                        actions.getOrganizationPostion().then((freshPersonPositionList) => {
                          const matchingPersonPositions = Array.isArray(freshPersonPositionList)
                            ? freshPersonPositionList.filter(p =>
                                (p.personGuid === record.personGuid || p.memberId === record.memberId) &&
                                p.positionLong === targetPositionLong
                              )
                            : [];

                          // Among matches for this role, the active/latest one is either the one
                          // with no expiry (still open-ended) or the one with the furthest expiryDt.
                          const latestPersonPosition = matchingPersonPositions.reduce((latest, current) => {
                            if (!latest) return current;
                            if (!latest.expiryDt) return latest;
                            if (!current.expiryDt) return current;
                            return moment(current.expiryDt).isAfter(moment(latest.expiryDt)) ? current : latest;
                          }, null);

                          const expiryIsInFuture = latestPersonPosition &&
                            (!latestPersonPosition.expiryDt || moment(latestPersonPosition.expiryDt).isAfter(moment(), 'day'));

                          if (expiryIsInFuture) {
                            // Person's position is still active per personPositionList, so extend
                            // directly instead of going through the assignFunctional/expiry flow.
                            const effectiveDate = moment(record.expireDate).add(1, 'day').format('YYYY-MM-DD');
                            const expiryDate = latestPersonPosition.expiryDt
                              ? moment(latestPersonPosition.expiryDt).format('YYYY-MM-DD')
                              : moment().add(1, 'year').format('YYYY-MM-DD');

                            actions.assignPersonPositionDirect(record.memberId, record.organizationGuid, record.personContext, effectiveDate, expiryDate)
                              .then(async () => {
                                setLoadingState(prev => ({ ...prev, [`${record.personGuid}-${record.organizationGuid}-${record.personContext}`]: false }));
                                setExtendRoleRecord({});
                                await actions.getAssignRolesPositions();
                                await actions.getOrganizationPostion();
                              })
                              .catch(() => {
                                setLoadingState(prev => ({ ...prev, [`${record.personGuid}-${record.organizationGuid}-${record.personContext}`]: false }));
                                setExtendRoleRecord({});
                              });
                          } else {
                            actions.getAssignRolesPersonGuid(record.personGuid, true); //ForExtendRole is true
                          }
                        });
                      }}
                      okText="Yes"
                      cancelText="No"
                      >
                        <Button
                          type="danger"
                          icon={<Icon type="delete" />}
                          className="role-remove-btn"
                          loading={loadingState[`${record.personGuid}-${record.organizationGuid}-${record.personContext}`] || false}
                        >
                          Extend Role
                        </Button>
                      </Popconfirm>                      
                  );
                },
              })
        }

        if (positionLong !== "Super Alumni Administrator" && tab != 'rolesAboutToExpire' ) {
            baseColumns.push({
            title: 'Role Remove',
            key: 'action',
            render: (_, record) => (
                <Popconfirm
                    title="Are you sure you want to remove this role?"
                    onConfirm={() => {
                                
                        // const findPersonPosition = positionList.find(pos => {
                        //     if(pos.personGuid === record.personGuid){
                        //         const date = new Date(record.effectiveDt).toISOString().slice(0, 10)
                        //     const effectiveOk = moment(pos.effectiveDate).isSame(date);
                          
                        //     let expireOk;
                        //     if (!pos.expireDate && !record.expiryDt) {
                        //       expireOk = true;
                        //     } else if (pos.expireDate && record.expiryDt) {
                        //         const date = new Date(record.expiryDt).toISOString().slice(0, 10)
                        //       expireOk = moment(pos.expireDate).isSame(date);
                        //     } else {
                        //       expireOk = {};
                        //     }
                        //     return effectiveOk && expireOk;
                        // }
                        // else {}
                          
                        //   });
                          
                        
                        handleDelete(
                            record.memberId,
                            // findPersonPosition.organizationGuid ?  findPersonPosition.organizationGuid : '',
                            record.personContext ?  record.personContext : '',
                            // // findPersonPosition.effectiveDate ?  findPersonPosition.effectiveDate : '',
                            {
                                ...record,
                                // pkPersonPositionId: record.personPositionId ? record.personPositionId : '',
                            }
                        )
                    }
                    }
                    okText="Yes"
                    cancelText="No"
                >
                    {  moment(record.expireDate).isAfter(moment()) ? <Button
                        type="danger"
                        icon={<Icon type="delete" />}
                        className="role-remove-btn"
                        style={{width: '100%'}}
                        loading={loadingState[`${record.personGuid}-${record.expireDate}`] || false}
                >
                        Remove
                    </Button> 
                    : <Alert message="Expired" type="error" showIcon /> }
                </Popconfirm>
            ),
        });
    }
        return baseColumns;
    };

    const isAddRoleDisabled = () => {
        if (selectedRole === 'AlumniCouncilCommittee') {
            return !(selectedRole && selectedTerritory && selectedCouncils && selectedCouncils.length > 0);
        }

        if (selectedRole === 'AlumniCSTSupport') {
            return !(selectedRole && selectedTerritory);
        }

        if (selectedRole === 'AlumniAdmin') {
            return !selectedRole;
        }

        return true;
    };

    const positionContextMap = {
        781: "AlumniCouncilCommittee",
        782: "AlumniCSTSupport",
        783: "AlumniAdmin",
        717: "Super Alumni Administrator"
    };

    // const mergedRoles = useMemo(() => {
    //     const positionMap = new Map();
    //     if (Array.isArray(positionList)) {
    //         for (const pos of positionList) {
    //             positionMap.set(pos.personGuid, pos);
    //         }
    //     }
    

    // const normalizePersonPositionList = (position) => {
    //     const matchingPosition = positionMap.get(position.personGuid);

    //     return {
    //         source: 'personPositionList',
    //         personGuid: position.personGuid,
    //         memberId: position.memberId,
    //         firstName: position.firstName,
    //         lastName: position.lastName,
    //         organizationGuid: position.organizationGuid,
    //         orgDisplayName: (matchingPosition && matchingPosition.orgDisplayName) || position.name,
    //         effectiveDate: position.effectiveDt,
    //         expireDate: position.expiryDt,
    //         positionId: position.positionId,
    //         pkPersonPositionId: position.personPositionId,
    //         personContext: positionContextMap[position.positionId],
    //     };
    // };

    // return Array.isArray(personPositionList)
    //     ? personPositionList.map(normalizePersonPositionList)
    //     : [];
    // }, [personPositionList, positionList]);

    // console.log('mergedRoles Response:', mergedRoles);
    console.log('personPositionList Response:', personPositionList);
    console.log('positionList Response:', positionList);

    const handleDelete = async (memberId, personContext, record) => {
        setLoadingState(prev => ({ ...prev, [`${record.personGuid}-${record.expireDate}`]: true }));

        const expiryDt = new Date().toISOString().split('T')[0];
        const futureDate = new Date();
        futureDate.setDate(futureDate.getDate() + 1);
        const futureDateStr = futureDate.toISOString().split('T')[0];

        const positionIdMap = {
            AlumniCouncilCommittee: 781,
            AlumniCSTSupport: 782,
            AlumniAdmin: 783,
            "SuperAlumniAdministrator": 717
        };

        let matchedPersonPosition, matchedPositionListEntry, functionalSuccess = false, positionSuccess = false;

        try {
            const positionId = positionIdMap[personContext];

            if (positionId) {
                matchedPersonPosition = Array.isArray(personPositionList)
                ? personPositionList.find(
                    (p) =>
                        p.personGuid === record.personGuid &&
                        p.positionId === positionId &&
                        moment(p.effectiveDt).isSame(record.effectiveDate, "day")
                )
                : null;      

                // throw new Error(`No hardcoded positionId found for role: ${personContext}`);
            }

                  

            matchedPositionListEntry = Array.isArray(positionList)
                ? positionList.filter(
                    p =>
                        p.personGuid === record.personGuid &&
                        p.personContext === personContext &&
                        p.effectiveDate === record.effectiveDate &&
                        p.expireDate === record.expireDate
                )
                : [];
                        /**
                 * Business Rule:
                 * - For most roles → only ONE org-level position should exist
                 * - For "Council Committee" → multiple council-level positions are allowed
                 *   within the same territory
                 *
                 * If more than one position exists:
                 * - Mark as multiple active registrations
                 * - Expire only via Position Dictionary API
                 * - Skip Org API unless exactly one org match exists
                 */
              const oneActiveRegistrationForMultipleCouncil = 
                matchedPositionListEntry.length > 1;
              
               matchedPositionListEntry =
                personContext === "AlumniCouncilCommittee" &&
                oneActiveRegistrationForMultipleCouncil
                  ? matchedPositionListEntry.filter(
                      p => p.orgDisplayName === record.orgDisplayName
                    )[0]
                  : matchedPositionListEntry[0];
              

            // if (!matchedPersonPosition || !matchedPositionListEntry) {
            //     Modal.error({
            //         className: "ErrorModal",
            //         title: `We Couldn't Match the Position`,
            //         content: `The positionId and positionContext in the API do not match.`,
            //     });
            //     throw new Error(`Mapping failed: personGuid=${record.personGuid}, positionId=${positionId}`);
            // }

            let expireFunctionalOrgGuid = matchedPersonPosition && matchedPersonPosition.organizationGuid;
            // let expireOrgGuid = matchedPositionListEntry.organizationGuid;

            if (expireFunctionalOrgGuid && !oneActiveRegistrationForMultipleCouncil) {
                await actions.expireFunctional({
                    personGuid: record.personGuid,
                    positionId,
                    pkPersonPositionId: matchedPersonPosition.personPositionId,
                    organizationGuid: expireFunctionalOrgGuid,
                    expiryDt
                });
                functionalSuccess = true;
            }

            if (matchedPositionListEntry && matchedPositionListEntry.organizationGuid) {
                await actions.expirePosition({
                    position: matchedPositionListEntry,
                    MID: memberId,
                    Role: personContext,
                    effectiveDate: futureDateStr,
                    oneActiveRegistrationForMultipleCouncil
                });

                positionSuccess = true;
            }

            Modal.success({ content: 'User role expired successfully!' });

            // await actions.expireAndRemoveFunctional({
            //     personGuid: record.personGuid,
            //     positionId,
            //     pkPersonPositionId: matchedPersonPosition.personPositionId,
            //     organizationGuid: expireFunctionalOrgGuid,
            //     position: matchedPositionListEntry,
            //     expiryDt,
            //     MID: memberId,
            //     Role: personContext,
            //     effectiveDate: futureDateStr,
            //     oneActiveRegistrationForMultipleCouncil
            // });

            actions.getAssignRolesPositions();
            actions.getOrganizationPostion();

            const tabMap = {
                "AlumniCouncilCommittee": "1",
                "AlumniCSTSupport": "2",
                "AlumniAdmin": "3"
            };
            if (tabMap[personContext]) {
                setActiveTabKey(tabMap[personContext]);
            }

        } catch (error) {

            if(positionSuccess && this.props.expirePositionError){
                Modal.warning({
                    title: 'Failed',
                    content: this.props.expirePositionError ? this.props.expirePositionError : 'Something went wrong',
                });
            }
            else if (functionalSuccess && this.props.expireFunctionalError) {
                Modal.warning({
                    title: 'Failed',
                    content: this.props.expireFunctionalError ? this.props.expireFunctionalError : 'Something went wrong',
                });
            } else {
                Modal.error({
                    title: 'Failed',
                    content: error.message ? error.message : 'Something went wrong',
                });
            }
        } finally {
            setLoadingState(prev => ({ ...prev, [`${record.personGuid}-${record.expireDate}`]: false }));
        }
    };


    const isDateWithIn30Days = (date) => {
        const expireDate = new Date(date);

        const date30inFuture = new Date();
        date30inFuture.setDate(date30inFuture.getDate() + 30);

        console.log('date30inFuture', date30inFuture);
        console.log('expireDate >= currentDate && expireDate <= date30inFuture', expireDate >= currentDate && expireDate <= date30inFuture);
        return expireDate >= currentDate && expireDate <= date30inFuture;
    }

    const getAboutToExpireRegistrations = useMemo(() => {
        if (!Array.isArray(positionList)) return [];

        const latestMap = new Map();

        positionList.sort((a, b) => a.memberId - b.memberId).forEach((pos) => {
            const key = `MID-${pos.memberId}-pGUID-${pos.personGuid}-orgGUID-${pos.organizationGuid}-personContext-${pos.personContext}`;

            if (!latestMap.has(key)) {
                latestMap.set(key, pos); //Set all the unique records in the Map
            }
            else {
                const existing = latestMap.get(key); //If its already exists check the latest record and set it in Map
                if (moment(pos.expireDate).isAfter(moment(existing.expireDate))) {
                    latestMap.set(key, pos);
                }
            }
        }
        );
        return Array.from(latestMap.values()).filter((pos) => //once set, Find the records that are about to expire in next 30days
            isDateWithIn30Days(pos.expireDate))
    }, [positionList]);
    

    const uniqueByPersonGuid = (list) => { 
        const map = new Map();
        list.forEach(item => {
            const existing = map.get(item.personGuid);
            if (!existing) {
                map.set(item.personGuid, item);
            } else {
                const existingDate = new Date(existing.effectiveDate);
                const currentDate = new Date(item.effectiveDate);
                if (currentDate > existingDate) {
                    map.set(item.personGuid, item);
                }
            }
        });
        return Array.from(map.values());
    };

    return (
        <div>
            <LayoutHeader />
            <AdminNavigation />
            <div className="new-roles-container">
                <Card bordered={false} style={{ width: '100%' }}>
                    <Tabs
                        defaultActiveKey="1"
                        activeKey={roleActiveTabKey}
                        onChange={(key) => {
                            roleSetActiveTabKey(key);

                            if (key === "2") {
                                actions.getAssignRolesPositions();
                                actions.getOrganizationPostion();
                            }
                            if (key === "3") {
                                if(!Array.isArray(personPositionList)) {
                                    actions.getAssignRolesPositions();
                                    actions.getOrganizationPostion();
                                }
                            }
                        }}
                    >
                        <TabPane tab={<span><Icon type="user-add" />Role Assignment</span>} key="1">

                            {/* <Card className="assign-form" title="Assign New Roles"> */}
                            <Form className="" layout="vertical" onSubmit={handleSubmit}>
                                <h4 className="assign-role-heading">Search for an alumni to assign a role</h4>
                                <Row className="label-row">
                                    <Col className="label-col">
                                        <Form.Item
                                            label="First Name"
                                            required
                                            validateStatus={formErrors.firstName ? 'error' : formValues.firstName ? 'success' : ''}
                                            help={formErrors.firstName}
                                            hasFeedback
                                        >
                                            <Input
                                                name="firstName"
                                                value={formValues.firstName}
                                                onChange={handleInputChange}
                                                placeholder="Enter First Name"
                                                className="custom-input"
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col className="label-col">
                                        <Form.Item
                                            label="Last Name"
                                            required
                                            validateStatus={formErrors.lastName ? 'error' : formValues.lastName ? 'success' : ''}
                                            help={formErrors.lastName}
                                            hasFeedback
                                        >
                                            <Input
                                                name="lastName"
                                                value={formValues.lastName}
                                                onChange={handleInputChange}
                                                placeholder="Enter Last Name"
                                                className="custom-input"
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col className="label-col">
                                        <Form.Item
                                            label="Member ID"
                                            required
                                            validateStatus={formErrors.memberId ? 'error' : formValues.memberId ? 'success' : ''}
                                            help={formErrors.memberId}
                                            hasFeedback
                                        >
                                            <Input
                                                name="memberId"
                                                value={formValues.memberId}
                                                onChange={handleInputChange}
                                                placeholder="Enter Member ID"
                                                className="custom-input"
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <div className="submit-btn-div">
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        disabled={searching}
                                        className="member-submit-btn"
                                    >
                                        {searching ? <Spin indicator={<LoadingOutlined className='adding-spin' spin />} size="small" /> : 'Search'}
                                    </Button>
                                </div>
                            </Form>
                            {/* </Card> */}

                            {(searching || userInfoLoading) ? (
                                <div className="loading-container spin-style">
                                    <Spin size="large" />
                                </div>
                            ) : (
                                <div>
                                    {searchResults.map((result, index) => (
                                        <div key={index} className="courses-container">
                                            <div className="course">
                                                <div className="course-preview">
                                                    <h2 className="userName">
                                                        {result.firstName} {result.lastName}
                                                    </h2>
                                                </div>
                                                <div className="course-info">
                                                    <div className="userDetailsDiv">
                                                        <Row className='role-row'>
                                                            <Col className='role-col-1'>
                                                                <h4 className="your-details">PII Information:</h4>
                                                                <h4>
                                                                    <span className="details-key">Name:</span> {result.firstName || '--'} {result.lastName || '--'}
                                                                </h4>
                                                                <h4>
                                                                    <span className="details-key">MID:</span> {result.memberId || '--'}
                                                                </h4>
                                                                <h4>
                                                                    <span className="details-key">Date of Birth:</span> {result.dateOfBirth || '--'}
                                                                </h4>
                                                                <h4>
                                                                    <span className="details-key">City:</span> {result.city || '--'}
                                                                </h4>
                                                            </Col>
                                                            <Col className='role-col-2'>
                                                                <h4 className="your-details">Contact Information:</h4>
                                                                <h4>
                                                                    <span className="details-key">Address:</span> {result.addressLine1 || '--'}
                                                                </h4>
                                                                <h4>
                                                                    <span className="details-key">Phone No:</span> {result.phone || '--'}
                                                                </h4>
                                                                <h4>
                                                                    <span className="details-key">Email:</span> {result.email || '--'}
                                                                </h4>
                                                                <h4>
                                                                    <span className="details-key">Zip Code:</span> {result.zip || '--'}
                                                                </h4>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={16} className="flex justify-content-between">
                                                            <Col span={8}>
                                                                <Form.Item label="Select Role">
                                                                    <Select
                                                                        placeholder="Select Role"
                                                                        style={{ width: '100%' }}
                                                                        onChange={(value) => handleRoleSelect(value)} 
                                                                        value={selectedRole}
                                                                        disabled={showCustomErrorPopup.disabledRoleSelection}
                                                                    >
                                                                        <Option value="AlumniCouncilCommittee">Alumni Council Committee</Option>
                                                                        <Option value="AlumniCSTSupport">Alumni CST Support</Option>
                                                                        <Option value="AlumniAdmin">Alumni Admin</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>

                                                            {(selectedRole === 'AlumniCouncilCommittee' || selectedRole === 'AlumniCSTSupport') && (
                                                                <Col span={8}>
                                                                    <Form.Item label="CST Territory">
                                                                        <Select
                                                                            placeholder="Select Territory"
                                                                            style={{ width: '100%' }}
                                                                            onChange={handleTerritorySelect}
                                                                        >
                                                                            <Select.Option key="F34FE9F3-E130-497A-857C-B32357E5DEC4" value="F34FE9F3-E130-497A-857C-B32357E5DEC4">
                                                                                Service Territory 01
                                                                            </Select.Option>
                                                                            <Select.Option key="2CDD5DCD-3949-444C-AD98-A65A5F953062" value="2CDD5DCD-3949-444C-AD98-A65A5F953062">
                                                                                Service Territory 02
                                                                            </Select.Option>
                                                                            <Select.Option key="A63A4D21-583F-4F88-8061-39D2FB1C40FF" value="A63A4D21-583F-4F88-8061-39D2FB1C40FF">
                                                                                Service Territory 03
                                                                            </Select.Option>
                                                                            <Select.Option key="3BF00C63-EE53-4784-B54C-8E5EA4937510" value="3BF00C63-EE53-4784-B54C-8E5EA4937510">
                                                                                Service Territory 04
                                                                            </Select.Option>
                                                                            <Select.Option key="36A1F5FC-B1EB-4596-A7D1-A74FBB595066" value="36A1F5FC-B1EB-4596-A7D1-A74FBB595066">
                                                                                Service Territory 05
                                                                            </Select.Option>
                                                                            <Select.Option key="FADA844F-BD27-4B91-B7B1-04F633F1AC29" value="FADA844F-BD27-4B91-B7B1-04F633F1AC29">
                                                                                Service Territory 06
                                                                            </Select.Option>
                                                                            <Select.Option key="4B12535B-F168-4353-98B6-FFC445757813" value="4B12535B-F168-4353-98B6-FFC445757813">
                                                                                Service Territory 07
                                                                            </Select.Option>
                                                                            <Select.Option key="71A7B7D0-B0E5-4D53-B85E-FEA22F6E2346" value="71A7B7D0-B0E5-4D53-B85E-FEA22F6E2346">
                                                                                Service Territory 08
                                                                            </Select.Option>
                                                                            <Select.Option key="31B4C008-7ED3-4955-ADDD-18FDD73A406F" value="31B4C008-7ED3-4955-ADDD-18FDD73A406F">
                                                                                Service Territory 09
                                                                            </Select.Option>
                                                                            <Select.Option key="F43E5346-0F59-4C05-B009-A1AB130068F4" value="F43E5346-0F59-4C05-B009-A1AB130068F4">
                                                                                Service Territory 10
                                                                            </Select.Option>
                                                                            <Select.Option key="FAF0451E-703D-43E1-BBD5-6A95D9B33317" value="FAF0451E-703D-43E1-BBD5-6A95D9B33317">
                                                                                Service Territory 11
                                                                            </Select.Option>
                                                                            <Select.Option key="BBE942BA-9EE7-4FB1-BE70-746359F96FCA" value="BBE942BA-9EE7-4FB1-BE70-746359F96FCA">
                                                                                Service Territory 12
                                                                            </Select.Option>
                                                                            <Select.Option key="F2E9CE02-232A-42AB-B393-630893BB7D79" value="F2E9CE02-232A-42AB-B393-630893BB7D79">
                                                                                Service Territory 13
                                                                            </Select.Option>
                                                                            <Select.Option key="E899B2A4-2438-4990-87F0-C8706107D05B" value="E899B2A4-2438-4990-87F0-C8706107D05B">
                                                                                Service Territory 14
                                                                            </Select.Option>
                                                                            <Select.Option key="B0BED118-E4ED-4DFE-9545-FE2DA8E38139" value="B0BED118-E4ED-4DFE-9545-FE2DA8E38139">
                                                                                Service Territory 15
                                                                            </Select.Option>
                                                                            <Select.Option key="D0B38022-713A-4166-8137-C1D9527DD434" value="D0B38022-713A-4166-8137-C1D9527DD434">
                                                                                Service Territory 16
                                                                            </Select.Option>

                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>
                                                            )}

                                                            {selectedRole === 'AlumniCouncilCommittee' && (
                                                                <Col span={16}>
                                                                    <Form.Item label="Select Council Name">
                                                                        <Select
                                                                            placeholder="Select Council Name"
                                                                            style={{ width: '100%' }}
                                                                            mode="multiple"
                                                                            onChange={handleCouncilSelect}
                                                                            value={selectedCouncils}
                                                                        >
                                                                            {councilsLoading ? (
                                                                                <Option disabled key="loading">
                                                                                    <Spin size="small" className="option-loading" />
                                                                                </Option>
                                                                            ) : (
                                                                                Array.isArray(getAllCouncils) && getAllCouncils.length > 0 ? (
                                                                                    getAllCouncils.map((council) => (
                                                                                        <Option key={council.organizationGuid} value={council.organizationGuid}>
                                                                                            {council.organizationName}
                                                                                        </Option>
                                                                                    ))
                                                                                ) : (
                                                                                    <Option key="no-data" value="" disabled>
                                                                                        No council Found
                                                                                    </Option>
                                                                                )
                                                                            )}
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>
                                                            )}
                                                        </Row>

                                                        <div className='role-btn-div'>
                                                            <Popconfirm
                                                                title="Are you sure you want to remove this section?"
                                                                onConfirm={() => handleCancel(index)}
                                                                okText="Yes"
                                                                cancelText="No"
                                                            >
                                                                <button className="butn yes-btn">
                                                                    <span>Cancel</span>
                                                                </button>
                                                            </Popconfirm>
                                                            <button onClick={() => handleConfirmRoleAssignment()} className={`butn yes-btn ${isAddRoleDisabled() ? 'disabled-btn' : ''}`} disabled={isAddRoleDisabled()} >
                                                                {assignRoleLoading ? <Spin indicator={<LoadingOutlined className='adding-spin' spin />} size="small" /> : 'Add Role'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </TabPane>

                        <TabPane tab={<span><Icon type="user-delete" />Role Removal</span>} key="2">
                            {loading ? (
                                <div className="loading-container spin-style">
                                    <Spin size="default" />
                                </div>
                            ) : (
                                <Tabs activeKey={activeTabKey} onChange={(key) => setActiveTabKey(key)} defaultActiveKey="1">
                                    <TabPane tab="Council Committee" key="1">
                                        <Table
                                            dataSource={Array.isArray(positionList)
                                                ?
                                                // councilCommitteeUser.filter(p => p.positionLong === 'Alumni Council Committee')
                                                //  uniqueByPersonGuid(
                                                    positionList.filter(p => p.personContext === 'AlumniCouncilCommittee').sort((a,b) => a.memberId - b.memberId)
                                                // )
                                                : []
                                            }
                                            columns={getColumns("Alumni Council Committee")}
                                            rowKey={(record) => `personGuid-${record.personGuid}-organizationGuid${record.organizationGuid}-orgDisplayName${record.orgDisplayName}`}
                                            pagination={false}
                                        />
                                    </TabPane>
                                    <TabPane tab="CST Support" key="2">
                                        <Table
                                            dataSource={Array.isArray(positionList)
                                                ?
                                                //  uniqueByPersonGuid(
                                                    positionList.filter(p => p.personContext === "AlumniCSTSupport").sort((a,b) => a.memberId - b.memberId)
                                                // )
                                                : []
                                            }
                                            columns={getColumns("Alumni CST Support")}
                                            rowKey={(record) => `${record.personGuid}-${record.organizationGuid}-${record.orgDisplayName}`}
                                            pagination={false}
                                        />
                                    </TabPane>
                                    <TabPane tab="Alumni Admin" key="3">
                                        <Table
                                            dataSource={Array.isArray(positionList)
                                                ?
                                                //  uniqueByPersonGuid(
                                                    positionList.filter(p => p.personContext === "AlumniAdmin").sort((a,b) => a.memberId - b.memberId)
                                                // )
                                                : []
                                            }
                                            columns={getColumns("Alumni Admin")}
                                            rowKey={(record) => `${record.personGuid}-${record.organizationGuid}-${record.orgDisplayName}`}
                                            pagination={false}
                                        />
                                    </TabPane>
                                    <TabPane tab="Super Alumni Admin" key="4">
                                        <Table
                                            dataSource={Array.isArray(superAdminInfo)
                                                ? superAdminInfo.filter((superAdmin) => superAdmin.positionLong === 
                                                "Super Alumni Administrator").sort((a,b) => a.memberId - b.memberId)
                                                : []
                                            }
                                            columns={getColumns("Super Alumni Administrator")}
                                            rowKey="personPositionId"
                                            pagination={false}
                                        />
                                    </TabPane>
                                </Tabs>
                            )}
                        </TabPane>
                        <TabPane tab={<span><Icon type="user" />Roles About To Expire <Icon type="exclamation-circle" style={{color:'orange'}} /></span>} key="3">
                            {loading ? (
                                <div className="loading-container spin-style">
                                    <Spin size="default" />
                                </div>
                            ) : (<Table
                                dataSource={getAboutToExpireRegistrations}
                                columns={getColumns(null , "rolesAboutToExpire")}
                                rowKey={(record) => `${record.personGuid}-${record.organizationGuid}-${record.orgDisplayName}`}
                                pagination={false}
                            />
                            )}
                        </TabPane>
                    </Tabs>
                </Card>
            </div >

            <Modal
                className='multiple-r-modal'
                title={false}
                footer={false}
                visible={duplicateModalVisible}
                centered
                onCancel={() => setDuplicateModalVisible(false)}
            >
                <div>
                    <span className='modal-header'>Multiple Records Found</span>
                    <span className='modal-desc'>Multiple records were found, please select one.</span>
                </div>
                {duplicateUsers.map((user, index) => (
                    <Row key={index} onClick={() => selectDuplicateUser(user)} className='eagle-results'>
                        <Col xs={23}>
                            <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Name: </b></span><span> {`${user.firstName} ${user.middleName ? user.middleName : ""} ${user.lastName}`} </span>
                                </Col>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Date of Birth: </b></span><span>    {user.memberId ? moment(user.memberId).format('MM/DD/YYYY') : '---'}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Member ID: </b></span><span>   {user.memberId ? user.memberId : '---'}</span>
                                </Col>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Board of Review Date:  </b></span><span>  {user.eagleBoardReviewDate ? user.eagleBoardReviewDate : '---'}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Eagle Flag:  </b></span><span>  {user.eagleBoardReviewDate ? 'Yes' : 'No'}</span>
                                </Col>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Awarding Council: </b></span><span>  {user.awardingCouncilName ? user.awardingCouncilName : '---'} </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council Unit Number: </b></span><span> {user.eagleTroopNumber ? user.eagleTroopNumber : "---"}</span>
                                </Col>

                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council City: </b></span><span>  {user.eagleCity ? user.eagleCity : '---'}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council State: </b></span><span>  {user.eagleState ? user.eagleState : '---'} </span>
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                ))}
            </Modal>

            <Modal
                className='No-records-Found-model'
                style={{ width: '600px' }}
                title={false}
                footer={false}
                visible={noRecordsModalVisible}
                centered
                onCancel={noRecordscloseModal}
            >
                <div className="center missing-div">
                    <div>
                        <img src={warningAlert} width="40px" height="40px" />
                    </div>
                    <div className='No-Results-Match-Pro'> Missing Information </div>
                    <div className='margin-bottom-20'> Whoops! it appears there is critical information regarding<br /> First Name, Last Name or Member ID, missing from your Eagle Scout record. </div>
                    <div> Please contact your Eagle Scout council to update your Eagle information. </div>

                    <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                        <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                            <div className='step-container margin-top-20' >
                                <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                    noRecordscloseModal();
                                }} htmlType='submit'>CLOSE </Button>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Modal>

            {showCustomErrorPopup.isShow && showCustomPopupModal()}
        </div >
    );
};

const mapStateToProps = (state) => ({
    searching: state.eagleGlobalReducer.searching,
    searchedGlobal: state.eagleGlobalReducer.eagle,
    loading: state.assignRolesPositionsReducer.loading,
    positionList: state.assignRolesPositionsReducer.positionList,
    superAdminInfo: state.GetSuperAdminReducer.superadmininfo,
    assignRoleLoading: state.userFunctionalRolesReducer.loading,
    assignRoleData: state.userFunctionalRolesReducer.roleData,
    roleRemoveLoading: state.removeUserRoleReducer.loading,
    expireFunctionalError: state.removeUserRoleReducer.error,
    
    expirePositionError: state.expireRoleReducer.error,
    userInfoLoading: state.assignRolesPersonGuidReducer.loading,
    userInfo: state.assignRolesPersonGuidReducer.userInfo,
    userInfoError: state.assignRolesPersonGuidReducer.error,
    activeRegistrationsLoading: state.activeRegistrationsReducer.loading,
    activeRegistrations: state.activeRegistrationsReducer.activeRegistrations,
    activeRegistrationsError: state.activeRegistrationsReducer.error,
    orgInfoLoading: state.childOrganzationReducer.loading,
    orgInfo: state.childOrganzationReducer.orgInfo,
    orgInfoError: state.childOrganzationReducer.error,
    councilsLoading: state.GetCouncilsReducer.loading,
    getAllCouncils: state.GetCouncilsReducer.GetAllCouncils,
    personPositionList: state.organizationPositionsReducer.personPositionList
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewRoles);


// WEBPACK FOOTER //
// ./src/components/Inc/NewRoles.js